export const MY_ZONE_ROUTE = '/my-zone/buy';
export const CONTINUE = 'Continue';
export const CALL_ME = 'call_me';
export const SHOW_INTEREST = 'show_interest';
export const MY_ZONE = 'my_zone';
export const CAR_COMPARISION = 'car_comparison';
export const COMPARE_PAGE_OPENED = 'compare-page-opened';
